import { controls, currencyToNumber, grouped } from "../../controls";

const rpsl1 = {
  label: "AADHAAR Authentication SLBC",
  starting: true,
  url: "rp101m",
  pageLabel: "AADHAAR Authentication SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "AADHAAR Authentication SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `Aadhar Authentication.txt`,
        format: {},
        separator: "|",
        // columns:["slbc_state_no","slbc_district_no","slbc_block_code","casa_count","seeded_count","auth_count"]
        skip_columns: []
      },
    },

    displayColumns: [
      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },
      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },
      {
        Header: "Block Code",
        accessor: "slbc_block_code",

      },
      {
        Header: "No of Operative CASA",
        accessor: "casa_count",
      },
      {
        Header: "No of Aadhar Seeded CASA",
        accessor: "seeded_count",
      },
      {
        Header: "No of Authenticated CASA",
        accessor: "auth_count",
      }
    ]
  }
};

export default rpsl1;